import React, {Component} from 'react';
import objeler from '../objeler';
import 'react-dropdown/style.css'
import './modal.css'

class FileProperties extends Component {
    options = [
        '6', '7', '8', '9'
    ];
    defaultOption = this.options[0];

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            activeFontFamily: "Open Sans",
            activeBold: "false"
        };
    };

    componentDidMount() {
        setTimeout(() => {
            this.child.select();
        }, 1);
    }

    updateInputValue(e) {
    }

    changeColor = (clr, event) => {
        objeler.tarik.Color = clr.hex;
    };
    changeBgColor = (clr, event) => {
        objeler.tarik.BColor = clr.hex;
    };

    onFontChage(e) {
        this.setState({value: e.target.value, text: e.target[e.target.selectedIndex].text});
        objeler.tarik.Font = e.target.value;
        objeler.tarik.FontFamily = e.target[e.target.selectedIndex].text;
    }

    onChangeBold(e) {
        objeler.ElementProps.Bold = e.target.checked;
    }

    onChangeItalic(e) {
        objeler.ElementProps.Italic = e.target.checked;
    }

    onFontSizeChage(e) {
        objeler.tarik.FontSize = e.target.value;
    }

    render() {
        const fontItems = {
            values: [
                {
                    name: 'Arial',
                    value: 'Arial',
                },
                {
                    name: 'Tahoma',
                    value: 'Tahoma',
                },
                {
                    name: 'Courier',
                    value: 'Courier',
                },
            ],
            value: '?',
        };
        const fontStyles = {
            values: [
                {
                    name: 'Regular',
                    value: 'Regular',
                },
                {
                    name: 'Bold',
                    value: 'Bold',
                },
                {
                    name: 'Italic',
                    value: 'Italic',
                },
                {
                    name: 'Bold Italic',
                    value: 'BoldItalic',
                },
            ],
            value: '?',
        };
        const {t, color, backgroundColor} = this.props;
        const prp = objeler["tarik"];
        const fontSizeStyle = {
            dispaly: "block",
            color: "Black",
            width: "60px",
            height: "25px",
            borderWidth: "1px",
            textAlignVertical: "middle",
            marginTop: "3px"
        };
        const trStyle = {
            borderWidth: "1px",
        };
        const tdStyle = {
            color: "Black",
            textAlign: "left",
            valign: "bottom"
        };
        const pStyle = {
            height: "16px",
            color: "#000000",
            fontFamily: 'Raleway, Arial',
            fontSize: "14px"
        };
        const tableStyle = {
            left: "47px",
            height: "60px",
            zIndex: "6"
        };
        const textStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            fontFamily: 'Raleway, Arial',
            fontSize: "14px",
            overflow: 'hidden'
        };
        const divStyle = {
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const dataSourceStyle = {
            display: "block",
            width: "100px",
            height: "25px",
            zIndex: "0"
        };
        const comboStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            vAlign: "middle"
        };
        return (
            <div style={divStyle}>
                <table style={tableStyle} id="Table1">
                    <tbody>
                    <tr>
                        <td className="cell0"><p style={pStyle}>&nbsp;File : </p></td>
                        <td className="cell1">
                <textarea name="TextArea1" id="TextArea1"
                          ref={abc => this.child = abc}
                          defaultValue={this.props.FileName}
                          onChange={this.props.onFileChange}
                          style={textStyle} rows="1" cols="20" spellCheck="false">
                </textarea>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default FileProperties;